import React , { useEffect, useRef, useState } from 'react';
// Import skelton
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import Button from "../button/button";

import sampleFile from "../../asstes/sample.pdf";

// Import the main component
import { Viewer, Worker, SpecialZoomLevel } from "@react-pdf-viewer/core";



function ProfileDetails({requestForInterview, applyTransition=false, hideProfile=false, loading=false, showLogin=false, profile, loadNextProfile, myRef,  meetingDetailPage=false }) {
  return (
    <div
    className={`hidden md:block col-span-6 ${
    applyTransition ? "showProfileTransition" : ""
    } ${hideProfile ? 'hideProfileTransition' : "" }`}
    >
        {/* Add div */}
        <div ref={myRef} className="bg-profile_background h-2xl w-full col-span-12"></div>

        {/* Body */}
        <div className="bg-blue-7 flex justify-center">
        <div className="w-11/12 lg:self-center ">
            {/* Personal View Sections */}
            <div className="col-span-12 grid grid-cols-12 gap-3 -mt-5 mx-3">
            {/* Basic Info section */}
            <div className="bg-white-1 col-span-12 grid grid-cols-12 gap-3 rounded font-Poppins pl-3 pt-5  pb-1 mb-1">
                {/* DP and Interview Button*/}
                <div className="col-span-12 grid grid-cols-12 gap-3">
                {/* Show skelton on loading*/}
                {loading ? (
                    <div className="col-span-12 grid grid-cols-12 gap-3">
                    <div className="col-span-6 h-20 w-20 -mt-24 md:h-40 md:w-40 md:-mt-28">
                        <Skeleton
                        circle={true}
                        height={`100%`}
                        width={`100%`}
                        />
                    </div>
                    </div>
                ) : (
                    <div
                    className={`col-span-12 grid grid-cols-12 gap-3`}
                    >
                    <div className="col-span-4 h-20 w-20 -mt-24 md:h-36 md:w-36 rounded-full bg-white-1 border-grey-1 border-2 relative">
                        <img
                        className={`h-24 w-20 flex justify-center items-center mt-5 absolute left-7`}
                        src={profile?.emoji_url}
                        alt="Avatar"
                        />
                    </div>
                    {!meetingDetailPage && <div className="col-span-8 flex justify-end mr-5">
                        {
                        (profile?.meetingTime && ( !showLogin || sessionStorage.getItem("publicInfo")) )? <div className="bg-pink-1 h-10 flex items-center text-base text-white-1 px-5 rounded-md">
                            Meeting: {profile?.meetingTime} - {profile?.endMeetingTime}
                        </div>  :
                            
                        <Button
                        name="Interview"
                        buttonType="Interview"
                        value="Request an Interview"
                        onClick={() => requestForInterview(profile?.id, profile?.full_name)} />
                        }
                    </div>}
                    </div>
                )}
                </div>

                {/* Name */}
                <div className="col-span-12">
                {/* Show skelton on loading*/}
                {loading ? (
                    <div className="col-span-12 mt-2 grid grid-cols-12 gap-3">
                    <div className="col-span-12 md:col-span-3">
                        <Skeleton height={35} width={300} />
                    </div>
                    </div>
                ) : (
                    <div className="col-span-12 grid grid-cols-12 gap-3">
                    {/* Add text */}
                    <div
                        className={`flex col-span-12 md:col-span-8 lg:col-span-9`}
                    >
                        <span className="text-black-1 text-lg font-normal">
                        {profile?.full_name}
                        </span>
                    </div>
                    </div>
                )}
                </div>

                {/* Location and TimeZone */}
                <div className="col-span-12 grid grid-cols-12 gap-3">
                {/* Show skelton on loading*/}
                {loading ? (
                    <div className="col-span-12 flex">
                    <Skeleton height={30} width={260} />
                    <div className="ml-40">
                        <Skeleton height={30} width={140} />
                    </div>
                    </div>
                ) : (
                    <div className="col-span-12 grid grid-cols-12 gap-3">
                    {/* Add location */}
                    {profile?.location && (
                        <div className="col-span-12 grid grid-cols-12">
                        <div className="flex col-span-12 md:col-span-6">
                            <img
                            className="mr-1.5 h-4 mt-0.5 -ml-0.5"
                            src="/location_icon2.svg"
                            alt="Avatar"
                            />
                            <span className="text-black-1 text-sm font-light">
                            {profile?.location}
                            </span>
                        </div>
                        <div className="flex col-span-12 md:col-span-6">
                            {/* Render exp */}
                            {profile?.timezone ? (
                            <div className="text-sm font-light flex">
                                <svg
                                className="-ml-0.5 mt-0.5 mr-1.5 h-4 w-4 fill-current text-black-1"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="18"
                                height="18"
                                >
                                <path fill="none" d="M0 0h24v24H0z" />
                                <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-8h4v2h-6V7h2v5z" />
                                </svg>
                                {profile?.timezone
                                .split(" ")[0]
                                .replace(/[\(\)]/g, "")}
                            </div>
                            ) : null}
                        </div>
                        </div>
                    )}
                    </div>
                )}
                </div>

                <div className="col-span-12 grid grid-cols-12 gap-3">
                {/* Show skelton on loading*/}
                {loading ? (
                    <div className="col-span-12 flex">
                    <Skeleton height={30} width={260} />
                    <div className="ml-40">
                        <Skeleton height={30} width={140} />
                    </div>
                </div>
                ) : (
                    <div className="grid grid-cols-12 gap-3 col-span-12">
                    {/* Add job title */}
                    <div className="col-span-12 grid grid-cols-12">
                        <div className="flex col-span-12 md:col-span-6">
                        {/* Render exp */}
                        {profile?.exp ? (
                            <div className="w-full text-[10px] font-normal text-black-2">
                            <div>EXPERIENCE</div>
                            <div className="text-black-1 text-sm">
                                {/* Text */}
                                {profile?.exp} Years
                            </div>
                            </div>
                        ) : null}
                        </div>
                        <div className="flex col-span-12 md:col-span-6">
                        {/* Render expected_hourly_rate */}
                        {profile?.client_hourly_rate ? (
                            <div className="w-full text-sm font-semibold text-black-1">
                            <div className="text-black-2 text-[10px] font-normal">
                                {" "}
                                {profile?.paymentFrequency && (profile?.paymentFrequency === 'Hourly' ?  'HOURLY RATE' : profile?.paymentFrequency === 'Monthly' ? 'MONTHLY COMPENSATION' : 'YEARLY COMPENSATION')}
                            </div>
                            {/* Text */}
                            <div>${new Intl.NumberFormat().format(profile?.client_hourly_rate)}</div>
                            </div>
                        ) : null}
                        </div>
                    </div>
                    </div>
                )}
                </div>

                {/* Add text */}
                <div className="col-span-12 grid grid-cols-12 gap-3">
                {/* Show skelton on loading*/}
                {loading ? (
                    <Skeleton height={35} width={330} />
                ) : (
                    <div className="col-span-12">
                    {/* Show skills */}
                    <div className="col-span-12 md:col-span-10 flex flex-wrap">
                        {/* Render tags */}
                        {profile?.skill_level.length > 0
                        ? profile?.skill_level.map((element, index) => (
                            <div
                                key={index}
                                className={`text-black-1 text-sm p-1 mr-2 mb-2 rounded-sm border-blue-7 bg-white-1 border-2 font-text whitespace-nowrap`}
                            >
                                {element.skill}
                            </div>
                            ))
                        : null}
                    </div>
                    </div>
                )}
                </div>
            </div>

            {/* Show download */}
            <div className="col-span-12 bg-white-1 rounded font-Poppins p-5 mb-5">
                {loading ? (
                <div className="col-span-12">
                    <div className="">
                    <Skeleton height={35} width={300} />
                    </div>
                </div>
                ) : (
                <div>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.12.313/build/pdf.worker.min.js">
                    <div
                        style={{
                        border: "1px solid rgba(0, 0, 0, 0.3)",
                        height: "1050px",
                        }}
                    >
                        <Viewer
                        fileUrl={profile?.cv_link ? profile?.cv_link : sampleFile}
                        defaultScale={SpecialZoomLevel.PageFit}
                        />
                    </div>
                    </Worker>
                </div>
                )}
                {!meetingDetailPage && <div className="flex justify-start mt-5">
                {
                    (profile?.meetingTime && ( !showLogin || sessionStorage.getItem("publicInfo")) ) ? <div className="bg-pink-1 h-10 flex items-center text-base text-white-1 px-5 rounded-md">
                    Meeting: {profile?.meetingTime} - {profile?.endMeetingTime}
                    </div> :

                    <Button
                    name="Interview"
                    buttonType="Interview"
                    value="Request an Interview"
                    onClick={() => requestForInterview(profile?.id, profile?.full_name)} />
                }
                </div>}
                {/* {!loading && <div className="flex justify-start mt-5">
                {(!isPublic && toLogin && profile?.meetingTime && !showLogin) && 
                    <Button
                    name="Interview"
                    buttonType="Interview"
                    value="Reschedule"
                    onClick={() => rescheduleInterview(profile?.id, profile?.full_name)}
                    
                    />
                }
                </div>}
                {!loading && <div className="flex justify-start mt-5">
                {(!isPublic && toLogin && profile?.meetingTime && !showLogin) && 
                    <Button
                    name="Interview"
                    buttonType="Interview"
                    value="Cancel"
                    onClick={() => cancelInterview(profile?.id, profile?.full_name)}
                    
                    />
                }
                </div>} */}
            </div>

            {/* Show Next Profile */}
            {(!loading &&  !meetingDetailPage) && <div className="col-span-12 font-semibold text-lg flex justify-start text-[#204ECF] mt-5 mb-10">
                <span className="cursor-pointer flex ml-5" onClick={loadNextProfile}>
                Next Profile
                <svg
                className="ml-1 mt-0.5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                >
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                    d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z"
                    fill="rgba(32, 78, 207, 1)"
                />
                </svg>
            </span>
            </div>}
            </div>
        </div>
        </div>
    </div>
  )
}

export default ProfileDetails